import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  type SubmitNPSResponsePayload,
  type SubmitNPSResponseResponse,
  submitNPSResponseMutation,
} from '@/api/surveys/submitNPSResponseMutation';
import { Logger } from '@/utils/logging';
import { Tracker } from '@/utils/tracking';

import type { UseSubmitNPSSurveyMutationOptions } from './types';

export const useSubmitNPSSurveyMutation = (
  options?: UseSubmitNPSSurveyMutationOptions,
) => {
  const queryClient = useQueryClient();

  return useMutation<
    SubmitNPSResponseResponse,
    Error,
    SubmitNPSResponsePayload
  >({
    ...submitNPSResponseMutation(),
    onError: (error, variables, onMutateResult, context) => {
      Logger.error('Error submitting NPS survey response', {
        error,
        variables,
      });
      options?.onError?.(error, variables, onMutateResult, context);
    },
    onSuccess: (data, variables, onMutateResult, context) => {
      Tracker.track('nps_survey_submitted', {
        userCampaignId: variables.userCampaignId,
      });
      void queryClient.invalidateQueries({
        queryKey: ['surveys', 'campaign', 'customernps'],
      });
      options?.onSuccess?.(data, variables, onMutateResult, context);
    },
  });
};
